import { RemoteFile } from "./RemoteFile";

export enum BatchStatus {
  Pending = "PENDING",
  Failed = "FAILED",
  Created = "CREATED",
  Cancelled = "CANCELLED",
  Sent = "SENT",
  Queued = "QUEUED",
}

export type LetterBatch = {
  id: string;
  name: string;
  status: BatchStatus;
  created: string;
  updated: string;
  lettersCount: number;
  letterPdfs: RemoteFile[];
  price: number;
};
